import { withConfig } from './withConfig'

export { withConfig }


// WEBPACK FOOTER //
// ./src/new_lib/index.js